import React from "react";

import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";

interface PageWrapperProps {
    children: React.ReactNode;
    pageTitle: string;
    currentPage?: string;
    previousPages?: PreviousPage[];
}

interface PreviousPage {
    title: string;
    url: string;
}

const PageWrapper: React.FC<PageWrapperProps> = ({ children, pageTitle, currentPage, previousPages }) => {
    return (
        <div>
            <h5 className="text-2xl font-bold text-gray-700 lg:text-3xl">{pageTitle}</h5>
            <Breadcrumb className="mb-4">
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <BreadcrumbLink href="dashboard">Dashboard</BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    {previousPages?.map((page, index) => (
                        <React.Fragment key={index}>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={page.url}>{page.title}</BreadcrumbLink>
                            </BreadcrumbItem>
                            <BreadcrumbSeparator />
                        </React.Fragment>
                    ))}

                    <BreadcrumbItem>
                        <BreadcrumbPage>{currentPage}</BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>
            {children}
        </div>
    );
};

export default PageWrapper;
